import { render, staticRenderFns } from "./FormCategoryAdditionalFee.vue?vue&type=template&id=60cb37d1&"
import script from "./FormCategoryAdditionalFee.vue?vue&type=script&lang=js&"
export * from "./FormCategoryAdditionalFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports